/** Per-device preferences kept in localStorage. */

const NAME_KEY = "op.peonName";

function read(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string | null): void {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch {
    /* private mode etc. */
  }
}

export function getPeonName(): string | null {
  const v = read(NAME_KEY)?.trim();
  return v ? v : null;
}

export function setPeonName(name: string | null): void {
  write(NAME_KEY, name?.trim() || null);
}

/**
 * Drops the per-household board cache (which task is "new") after a household
 * switch. The peon name and tutorial flags stay: they belong to the device,
 * not the household.
 */
export function resetHouseholdState(): void {
  try {
    localStorage.removeItem("op.seenTasks");
    // The Hall's saved months (shared/hall-memory.ts): the new household's Hall must not paint the old one's.
    localStorage.removeItem("op.hall");
  } catch {
    /* private mode etc. */
  }
}

export function deviceTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}
